import React from 'react';
import StatusDot from '../../../../../components/StatusDot/StatusDot';
import ButtonIcon from '../../../../../components/ButtonIcon/ButtonIcon';
import Avatar from '../../../../../components/Avatar/Avatar';
import ApproveIcon16 from '../../../../../assets/svg/icons/common/ApproveIcon16';
import DeclineIcon16 from '../../../../../assets/svg/icons/common/DeclineIcon16';
import styles from './style.module.scss';
import { transformActionType, getApprovalDescription } from '../../utils';
import Tiered from '../../../../application/components/MerchantDetails/Pricing/Tiered';
import Surcharge from '../../../../application/components/MerchantDetails/Pricing/Surcharge';
import DualPricing from '../../../../application/components/MerchantDetails/Pricing/DualPricing';
import FlatRate from '../../../../application/components/MerchantDetails/Pricing/FlatRate';
import ICPlus from '../../../../application/components/MerchantDetails/Pricing/ICPlus';
import Ach from '../../../../application/components/MerchantDetails/Pricing/Ach';
import OtherFees from '../../../../application/components/MerchantDetails/Pricing/OtherFees';

const ApprovalItem = ({ item, onApprove, onDecline, isPending = false, appData }) => {
  const isApproved = (item.status || '').toLowerCase() === 'approved';
  const resolutionVerb = isApproved ? 'Approved' : 'Declined';

  const renderPricing = () => {
    if (appData?.qualifiedtype === "tiered") return <Tiered appData={appData} />;
    if (appData?.qualifiedtype === "surcharge")
      return <Surcharge appData={appData} />;
    if (appData?.qualifiedtype === "dual_pricing")
      return <DualPricing appData={appData} />;
    if (appData?.qualifiedtype === "flat_rate")
      return <FlatRate appData={appData} />;
    if (appData?.qualifiedtype === "ic_plus")
      return <ICPlus appData={appData} />;
    if (appData?.qualifiedtype === "ach")
      return <Ach appData={appData} />;
  };

  return (
    <div className={styles.approvalItem}>
      <div className={styles.itemContent}>
        <div className={styles.actionType}>
          <span className={styles.label}>Type of Action:</span>
          <span className={styles.value}>{transformActionType(item.action_type)}</span>
        </div>
        <div className={styles.description}>
          {getApprovalDescription(item).split(';').map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              {idx < getApprovalDescription(item).split(';').length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>

        {item?.action_type == 'soft_limit_breach' && (
          <>
            <div className={styles.actionType}>
              <span className={styles.label}>Pricing:</span>
            </div>
            <div className={`${styles.description} ${styles.pricing}`}>
              {renderPricing()}
              {appData?.prices?.length > 0 && (
                <OtherFees appData={appData} />
              )}
            </div>
          </>
        )}

        {!isPending && item.approval_notes && (
          <div className={styles.notes}>
            <span className={styles.label}>Notes:</span>
            <span className={styles.value}>{item.approval_notes}</span>
          </div>
        )}
        {/* <div className={styles.createdInfo}>
          <span className={styles.createdText}>Created {item.created_ago}</span>
          {item.agent_name !== 'N/A' && (
            <div className={styles.agentInfo}>
              <span>by</span>
              <Avatar className={styles.agentAvatar} size="xs" name={item.agent_name.slice(0, 1)} />
              <span className={styles.agentName}>{item.agent_name}</span>
            </div>
          )}
        </div> */}
        {item?.approver_name !== 'N/A' && (
          <div className={styles.createdInfo}>
            <span className={styles.createdText}>
              {resolutionVerb} {item.approved_ago}
            </span>
            {item.approver_name !== 'N/A' && (
              <div className={styles.agentInfo}>
                <span>by</span>
                <Avatar className={styles.agentAvatar} size="xs" name={item.approver_name.slice(0, 1)} />
                <span className={styles.agentName}>{item.approver_name}</span>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles.itemFooter}>
        {isPending ? (
          <div className={styles.actions}>
            <ButtonIcon
              bgColor="#37B450"
              textColor="#fff"
              onClick={onApprove}
              className={styles.approveButton}
            >
              <ApproveIcon16 />
              <span>Approve</span>
            </ButtonIcon>
            <ButtonIcon
              bgColor="#fff"
              textColor="#FF4D4F"
              className={styles.declineButton}
              onClick={onDecline}
            >
              <DeclineIcon16 />
              <span>Decline</span>
            </ButtonIcon>
          </div>
        ) : (
          <div className={`${styles.status} ${isApproved ? styles.statusApproved : styles.statusRejected}`}>
            <StatusDot color={isApproved ? '#37B450' : '#FF4D4F'} />
            <span>{resolutionVerb}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApprovalItem;